import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * The one focus indicator.
 *
 * Fifteen files each declared their own `EMBER_FOCUS` constant with the same
 * string, which meant the app had fifteen chances to drift and no single place
 * to fix the ring when it turned out to be composited at 1.68:1 — below the 3:1
 * that SC 1.4.11 requires, and the only indicator any of those files had.
 *
 * `outline-none` is safe here only because the shadow replaces it. Never use
 * one without the other; `--shadow-focus` itself is two opaque layers so the
 * ring reads on the page, on a card and on an inset alike.
 *
 * The `ring-0` / `ring-offset-0` resets are deliberate: several shadcn New York
 * primitives ship their own `focus-visible:ring-*`, and a second indicator
 * drawn in a different colour reads as two overlapping states. This constant is
 * a superset of every hand-rolled variant it replaced, so swapping one out can
 * only add resets, never drop them.
 */
export const FOCUS_RING =
  "outline-none focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:shadow-[var(--shadow-focus)]";

/**
 * The same ring for a control whose visible box is a wrapper rather than the
 * focusable element itself — a text input inside a bordered shell, say.
 */
export const FOCUS_RING_WITHIN = "focus-within:shadow-[var(--shadow-focus)]";
